import { Stack, Typography } from '@mui/material'
import type { FC, ReactNode } from 'react'
import { ErrorMessage } from 'src/components/errorMessage/ErrorMessage'

type Props = {
  label: string
  required?: boolean
  /** 利用者向けの注意書き。入力の下に出す */
  note?: string
  /** この欄の理由（フォームの判定・試算・保存の 400） */
  errors?: string[]
  children: ReactNode
}

/**
 * フォームの 1 欄。旧スケジュールの編集フォーム（ScheduleNameRow など）と同じ体裁。
 * ラベル・入力・「※必須入力」・注意書き・理由 の順に縦に並べる。
 */
export const FieldBlock: FC<Props> = ({
  label,
  required,
  note,
  errors = [],
  children,
}) => (
  <Stack spacing={1}>
    <Typography variant="subtitle1" fontWeight="bold">
      {label}
    </Typography>
    {children}
    {required && <Typography variant="caption">※必須入力</Typography>}
    {note && <Typography variant="caption">{note}</Typography>}
    {errors.length > 0 && (
      <Stack>
        {errors.map(message => (
          <ErrorMessage key={message} noMargin>
            {message}
          </ErrorMessage>
        ))}
      </Stack>
    )}
  </Stack>
)
